// extracted by mini-css-extract-plugin
export default {"infoText":"infoText_infoText__D11CL"};